import { Box } from "@chakra-ui/layout";
import { Text, Link } from "@chakra-ui/react";
import { ExternalLinkIcon } from '@chakra-ui/icons';

const Test = ({ test, link }) =>
(
    <>
    <Box h="5px" />
    <Box bg="green.200" p="20px" borderRadius="md">
        <Link href={link} isExternal>
            <Text as="b">TEST <ExternalLinkIcon mx="2px" /></Text>
        </Link>
        <Text>{test}</Text>
    </Box>
    <Box h="5px" />
    </>
);

export default Test;